import React from 'react';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade'; // web.cjs is required for IE 11 support
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
//import AppBar from '@material-ui/core/AppBar';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { connect } from 'react-redux';
import SignInLawyer from './container/SignInLawyer';
import SignInClient from './container/SignInClient';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box
        p={5}
        padding='0'
        maxWidth="960px"
      >
        {children}
      </Box>
    </Typography>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'Column',
    width: 530,
    //minHeight: 272,
    borderRadius: 4,
    padding: '16px 16px 16px 24px',
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none',
    },
  },
  close: {
    display: 'flex',
    justifyContent: 'flex-end',
    cursor: 'pointer',
    //marginTop: isMobile? 16 : 0, 
  },
  infoWrapper: {
    //padding: '32px 38px 0',
    //display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
  tabs: {
    padding: '0 20px',
    '@media (max-width: 1280px)': {
      padding: 0,
    },
  },
  indicator: {
    height: 2,
    backgroundColor: '#013957',
  },
  tabsContainer: {
    //width: 'fit-content',
    margin: 'auto',
  },
  tabStyle: {
    height: 66,
    padding: '0 32px',
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    textTransform: 'none',
    borderBottom: '1px solid #e7e7e7',
    width: '50%',
    '&$selected': {
      color: '#013957',
    },
    // '@media (max-width: 424px)': {
    //   width: 140,
    // },
  },
  selected: {},
  textColorPrimary: {
    color: '#c1c1c1',
  },
  tabWrapper: {
    display: 'contents',
  },
  panel: {
    padding: 0,
  }
}));

const ModalSignIn = ({ open, handleClose }) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const classes = useStyles();

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div onClick={handleClose} className={classes.close}>
              <img src="/img/icons/close.svg" alt="close" />
            </div>
            <div className={classes.infoWrapper}>
              <Tabs
                value={value}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
                aria-label="disabled tabs example"
                classes={{
                  root: classes.tabs,
                  indicator: classes.indicator,
                  flexContainer: classes.tabsContainer,
                  scrollButtonsDesktop: classes.scrollButtonsDesktop,
                }}
              >
                <Tab
                  label="Inicia como abogado"
                  classes={{
                    root: classes.tabStyle,
                    selected: classes.selected,
                    textColorPrimary: classes.textColorPrimary,
                    wrapper: classes.tabWrapper,
                  }}
                />
                <Tab
                  label="Inicia como usuario"
                  classes={{
                    root: classes.tabStyle,
                    selected: classes.selected,
                    textColorPrimary: classes.textColorPrimary,
                    wrapper: classes.tabWrapper,
                  }}
                />
              </Tabs>
              <TabPanel className={classes.panel} value={value} index={0}>
                <SignInLawyer />
              </TabPanel>
              <TabPanel className={classes.panel} value={value} index={1}>
                <SignInClient />
              </TabPanel>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

/* const mapDispatchToProps = (dispatch) => ({

}); */

const mapStateToProps = (state) => ({
  //uid: state.authClient.uid,
});

export default connect(mapStateToProps)(ModalSignIn);
